let authUpgradeNavigationPending = false;

export const markAuthUpgradeNavigationPending = () => {
  authUpgradeNavigationPending = true;
};

export const clearAuthUpgradeNavigationPending = () => {
  authUpgradeNavigationPending = false;
};

export const isAuthUpgradeNavigationPending = () => authUpgradeNavigationPending;
